import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
	// A list of all messages that are supported
	locales: ['nl', 'en'],

	// Used when no locale matches
	defaultLocale: 'nl',

	localePrefix: 'as-needed',

	pathnames: {
		"/": "/",

		"/voor-wie": {
			nl: "/voor-wie",
			en: "/for-whom",
		},
		"/voor-wie/patienten": {
			nl: "/voor-wie/patienten",
			en: "/for-whom/patients",
		},
		"/voor-wie/huisartsenposten": {
			nl: "/voor-wie/huisartsenposten",
			en: "/for-whom/general-practitioners",
		},
		"/voor-wie/zorgverzekeraars": {
			nl: "/voor-wie/zorgverzekeraars",
			en: "/for-whom/health-insurers",
		},
		"/voor-wie/gemeenten": {
			nl: "/voor-wie/gemeenten",
			en: "/for-whom/municipalities",
		},
		"/over-ons": {
			en: "/about-us",
			nl: "/over-ons",
		}
	}
});

export type AppPathname = keyof typeof routing.pathnames;

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
